const WordGame = () => (
    <div className="p-4">
      <h2 className="text-2xl font-bold">Word Race</h2>
      <p>Game logic coming soon!</p>
    </div>
  );
  export default WordGame;
  